// extracted by mini-css-extract-plugin
export default {"container":"Login_container__XiMTb","register":"Login_register__Z7eAA"};